/**
 * @desc: - 添加收藏
 * @author: ammo
 */
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { LOTTERY_MENUS } from '../../../constants/menus/lotteryMenus'

export class AddFavorites extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      displayForm: 0,
      userPreference: false,
      hideBtn:false
    }
  }

  componentDidMount(){
    this.resetMenuPosition();
    window.addEventListener('resize', () => this.resetMenuPosition());
    window.setTimeout(() => this.setState({show: 1}), 10000)
  }

  componentWillUnmount(){
    window.removeEventListener('resize', () => this.resetMenuPosition(), false);
  }

  /**
   * 切换显示状态 0: 有倒计时的, 1 没有倒计时的, 2是打开编辑，3就是所有彩种
   * @author ammo 2018-06-27
   * @param  {[type]} status [description]
   * @return {[type]}        [description]
   */
  switchDisplayFrom(status, byClick=false){
    this.setState({
      displayForm: status,
      userPreference: byClick || this.state.userPreference
    })
    if (status == 0) {
      _.delay(() => this.resetMenuPosition(), 200)
      this.props.showMenu();
    }
    
  }
  /*通过传递这个函数给子组件来控制父组件隐藏菜单的显示*/
  handleHideMenu(str=false){
    this.setState({
      hideBtn:str || this.state.hideBtn
    })
    this.props.hideMenu();
  }
  //重新计算侧栏菜单的left值
  resetMenuPosition(){
    const availWidth = document.documentElement.clientWidth;
    const maxWidth = 1080 + 40 + 320;
    const minWidth = 1080;
    // 当显示的是大面板的时候
    if (this.state.displayForm == 0) {
      this.setState({
        hideBtn:false
      });
      // 最大宽度时
      if (availWidth >= maxWidth) {
        this.setState({userPreference:false});
        if(document.querySelector('.favorites-pannel-container')){
          return document.querySelector('.favorites-pannel-container').style.left = '-220px';
        }else{
          return;
        }
      }
      // 最大宽度到最小宽度间
      if (availWidth >= minWidth && availWidth < maxWidth) {
        this.setState({userPreference:false});
        if((140 + ((availWidth - 1080) / 2  - 160)) > 0){
          return document.querySelector('.favorites-pannel-container').style.left = '-' + (140 + ((availWidth - 1080) / 2  - 160)) + 'px';
        }
        if((140 + ((availWidth - 1080) / 2  - 160)) < 0){
          return document.querySelector('.favorites-pannel-container').style.left = (140 + ((availWidth - 1080) / 2  - 160)) + 'px';
        }
      }
      // 最小宽度时
      // 如果用户手动控制过那么不在由RESIZE控制
      if (this.state.userPreference) {
        return document.querySelector('.favorites-pannel-container').style.left = '20px'
      }
      return this.setState({displayForm: 1});
    }

    // 当显示小面板的时候
    if (this.state.displayForm === 1 && !this.state.userPreference) {
      if(this.state.hideBtn){
        return;
      }
      if (availWidth >= minWidth) {
        return this.setState({displayForm: 0});
      }
    }
  }

  render() {
    const { favorites } = this.props.__COMMON.toJS();
    const { sale_info } = this.props.__LOTTERY.toJS();
    const { _window } = this.props.__METHOD.toJS();
    return (
      <div>
        {
          _.includes([0,2,3], this.state.displayForm) &&
          <FavoritesPannel 
            switchForm={(status) => this.switchDisplayFrom(status)}
            favorites={favorites.lottery}
            sale_info={sale_info} 
            alias={this.props.alias}
            createFn={this.props.$$COMMON.createFavorites}
            deleteFn={this.props.$$COMMON.deleteFavorites}
            alertFn={this.props.$$BASE.openToast}
            displayForm={this.state.displayForm}
            common = {this.props.$$COMMON}
            hideMenu = {this.handleHideMenu.bind(this)}
          />
        }
        {
          this.state.displayForm == 2 && 
          <FavoritesList 
            favorites={favorites.lottery} 
            createFn={this.props.$$COMMON.createFavorites}
            deleteFn={this.props.$$COMMON.deleteFavorites}
            alertFn={this.props.$$BASE.openToast}
            switchForm={(status) => this.switchDisplayFrom(status)}
            getLotterySaleInfo = {this.props.$$LOTTERY.getLotterySaleInfo}
          />
        }
        {
          this.state.displayForm == 1 && 
          <div onClick={() => this.switchDisplayFrom(0, true)} className='trend_chart addfavorite' ><b />我的收藏</div>
        }
      </div>
    );
  }
}

reactMixin(AddFavorites.prototype, ImmutableMixin);

function mapStateToProps(state) {
  return {
    __COMMON: state.common,
    __LOTTERY: state.lottery,
    __METHOD: state.method
  }
}

function mapDispatchToProps(dispatch) {
  return {
    $$BASE: bindActionCreators(baseAction, dispatch),
    $$COMMON: bindActionCreators(commonAction, dispatch),
    $$LOTTERY: bindActionCreators(lotteryAction, dispatch)
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AddFavorites)


class FavoritesPannel extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
    }
  }

  componentDidMount(){
    this.makeFavoritesPanel(this.props);
  }

  componentWillUnmount(){
    if (this.loop) {
      window.clearInterval(this.loop);
      this.loop = null;
    }
  }

  componentWillReceiveProps(nextProps){
    this.makeFavoritesPanel(nextProps)
  }

  setCountDown(sale_info, lottery){
    if (lottery.flaglot == 'mmc') {
      return null
    }

    const lotteryMenu = _.find(sale_info, {lotteryid: lottery.lotteryId});
   
    if (!lotteryMenu || !lotteryMenu.saleend) {
      return null;
    }

    const countdown = ($.momentDate(lotteryMenu.saleend).toDate().getTime() - $.momentDate(window.serverTime * 1000).toDate().getTime()) / 1000;

    if(countdown <= 0){
      return lotteryMenu.next_cycle + countdown;
    }
    return countdown;
  }

  setIssueCycle(sale_info, lottery){
    if (lottery.flaglot == 'mmc') {
      return null
    }
    
    const find_cycle = _.find(sale_info, {lotteryid: lottery.lotteryId});
    if(!find_cycle){
      return null;
    }
    return find_cycle.next_cycle;
  }

  makeFavoritesPanel(props){
    const { favorites, sale_info } = props;$.makeLott(LOTTERY_MENUS)
    if (!favorites || favorites.length === 0 || sale_info.length === 0) {return;}
    if (_.isEqual(this.state.favorites, favorites) && _.isEqual(this.state.sale_info, sale_info)) {return;}
    let lotterys = _.chain($.makeLott(LOTTERY_MENUS))
                    .map('lotterys')
                    .flatten()
                    .filter((item) => _.includes(_.map(favorites, 'target_id'), String(item.lotteryId)))
                    .map((item) => ({
                      id: item.lotteryId,
                      name: item.name,
                      uri: item.uri,
                      countdown: this.setCountDown(sale_info, item),
                      next_cycle: this.setIssueCycle(sale_info, item),
                      alias: item.flaglot,
                      created_at: _.find(favorites, {target_id: String(item.lotteryId)}).created_at,
                      order: _.findIndex(favorites, {target_id: String(item.lotteryId)})
                    }))
                    .orderBy(['order'])
                    .value();
    // 宽度
    _.each(lotterys, function(lottery){
      if (!lottery.countdown && lottery.countdown !== 0) {
        return true;
      }
      lottery.width = (100 - (lottery.countdown == 0 ? 0 :  Math.round((lottery.countdown * 100) / lottery.next_cycle))) + '%';
    })
    this.setState({
      lotterys: lotterys,
      sale_info: sale_info,
      favorites: favorites
    })

    this.lotterys = lotterys;
    this.makeCountDown();
  }

  // 生成倒计时
  makeCountDown(){
    if (this.loop) {
      window.clearInterval(this.loop);
    }
    this.loop = window.setInterval(function(){
      _.each(this.lotterys, function(lottery){
        if (!lottery.countdown && lottery.countdown !== 0) {
          return true;
        }
        if (lottery.countdown <= 0) {
          lottery.countdown = lottery.next_cycle - 1;
        }else{
          //当前时间所走的长度
          lottery.countdown = lottery.countdown - 1;
        }
        const currentWidth = (100 - (lottery.countdown == 0 ? 0 :  Math.round((lottery.countdown * 100) / lottery.next_cycle))) + '%';
        lottery.width = currentWidth;
      })
      this.setState({
        lotterys: this.lotterys
      })
    }.bind(this), 1000)
  }
  //隐藏菜单按钮
  hideMenu(){
    this.props.hideMenu(true);
    this.props.switchForm(1);
  }
  render() {
    return (
      <div className='favorites-pannel-container' ref="widBox">
        <h6></h6>
        <div className='content'>
          {
            this.state.lotterys && this.state.lotterys.map((item, key) => 
              <div className={this.props.alias == item.alias ? 'item current' : 'item'} key={key} onClick={() => window.location.href = item.uri}>
                <div className="lottery_name">
                  <div className='name'>
                    <span>{item.name}</span>
                    <i className={item.type}></i>
                  </div>
                  <div className={item.countdown && item.countdown <= 10 ? 'red countdown' : 'countdown'}>
                    {
                      item.countdown || item.countdown === 0 ? 
                        $.formatTime(item.countdown > item.next_cycle ? item.next_cycle : item.countdown)
                        : 
                        '--:--:--'
                    }
                  </div>
                </div>
                <div className="progress">
                  <b className={item.countdown && item.countdown <= 10 ? 'progress_red progress_bar' : 'progress_bar'} style={{width: item.width || 0}}></b>
                </div>
              </div>
            )
          }
          <div className='edit'>
            <a href="javascript:;" className="button" onClick={() => this.props.switchForm(2)}>添加/编辑</a>
          </div>
          <div className='hidden-menu' onClick={this.hideMenu.bind(this)}>
            <span>隐藏菜单</span>
          </div>
        </div>
      </div>
    );
  }
}

class FavoritesList extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      favorites: _.map(_.filter(this.props.favorites, (o) => o.id != 0), (item) => parseInt(item.target_id)) || []
    }
  }

  handleSelectLottery(lotteryId){
    const fixlength = _.filter(this.props.favorites, (o) => o.id == 0).length;
    if (_.includes(this.state.favorites, lotteryId)) {
      // 删除
      this.setState({
        favorites: _.filter(this.state.favorites, (item) => item !== lotteryId)
      })
    }else{
      if (this.state.favorites.length + fixlength >= 10) {
        return this.props.alertFn('最多只能收藏10个彩种哦')
      }
      // 添加
      this.setState({
        favorites: _.concat(this.state.favorites, lotteryId)
      })
    }
  }

  handleClear(){
    this.setState({
      favorites: []
    })
  }

  handleSubmit(){
    const { createFn, deleteFn, favorites, closeFn, switchForm } = this.props;
    const ids = _.map(_.filter(favorites, (o) => o.id != 0), (item) => parseInt(item.target_id));
    const removeIds = _.filter(ids, (item) => !_.includes(this.state.favorites, item));
    const createIds = _.filter(this.state.favorites, (item) => !_.includes(ids, item));
    // 添加
    if (createIds && createIds.length > 0) {
      const request = _.chain($.makeLott(LOTTERY_MENUS))
                       .map('lotterys')
                       .flatten()
                       .filter((item) => _.includes(createIds, item.lotteryId))
                       .map((item) => ({
                          title: item.name,
                          target_id: item.lotteryId,
                          remark: ''
                        }))
                       .value();
      createFn('lottery', {collection: request});           
    }
    // 删除
    if (removeIds && removeIds.length >0) {
      deleteFn({id: _.chain(_.filter(favorites, (o) => o.id != 0)).filter((item) => _.includes(removeIds, parseInt(item.target_id))).map('id').value()})
    }
    switchForm(0);

    //重新获取sale_info,确保saleend为最新值
    this.props.getLotterySaleInfo();
  }

  render() {
    const { favorites } = this.state;
    return (
      <div className='favorites-list-container'>
       <div className='overlay-fake' />
       <div className='content'>
        <h3>添加常玩彩种<i className='close' onClick={() => this.props.switchForm(0)} /></h3>
        <div className='lotterys'>
          {
            $.makeLott(LOTTERY_MENUS).map((category, index) => 
              <div className='category' key={index}>
                <div className='title'>{category.categoryName}：</div>
                <div className='lottery-items'>
                  {
                    category.lotterys.map((lottery, index) => 
                      _.chain(this.props.favorites).find({target_id: lottery.lotteryId.toString()}).get('id') != 0 &&
                      <div key={index}>
                        <span onClick={() => this.handleSelectLottery(lottery.lotteryId)} className={_.includes(favorites, lottery.lotteryId) ? 'check' : 'uncheck'}>
                          <i  />
                          {lottery.name}
                        </span>
                      </div>
                    )
                  }
                </div>
              </div>
            )
          }
        </div>
        <div className='submit'>
          <div className="submit-tips">温馨提示：最多可选10个彩种</div>
          <button onClick={() => this.handleSubmit()}>确定</button>
          <a onClick={() => this.handleClear()}>清空</a>
        </div>
       </div>
      </div>
    );
  }
}

// 所有彩种
class AllLotterys extends React.Component {

  constructor(props) {
    super(props);
    this.throttled = {};
    this.throttledTimter = {};
    this.state = {
      favorites: _.map(this.props.favorites, (item) => parseInt(item.target_id)) || []
    }
  }

  componentWillUnmount(){
    _.each(this.throttledTimter, function(item, key){
      window.clearTimeout(item);
      item = null;
    })
  }

  handleSelectedLottery(e, lotteryId){
    e.stopPropagation();
    const { createFn, deleteFn, favorites, closeFn, switchForm, alertFn } = this.props;
    if (!_.includes(this.state.favorites, lotteryId) && this.state.favorites.length == 10) {
      return this.props.alertFn('最多只能收藏10个彩种哦')
    }
    // 节流
    if (this.throttled[lotteryId]) {
      return alertFn('您的操作太频繁，请稍后再试')
    };
    this.throttled[lotteryId] = true;
    this.throttledTimter[lotteryId] = setTimeout(() => {
      this.throttled[lotteryId] = false; 
    }, 5000);

    // 删除
    if (_.includes(this.state.favorites, lotteryId)) {
      this.setState({
        favorites: _.filter(this.state.favorites, (item) => item !== lotteryId)
      })
      return deleteFn({id: [_.find(this.props.favorites, {target_id: String(lotteryId)}).id]});
    }

    // 添加
    this.setState({
      favorites: _.concat(this.state.favorites, lotteryId)
    })
    return createFn('lottery', {collection: [{target_id: lotteryId}]})

  }

  render() {
    const { switchForm } = this.props;
    const { favorites } = this.state;
    return (
      <div className="all-lottery" id='all-lotterys' onMouseEnter={() => switchForm(3)} onMouseLeave={() => switchForm(0)}>
        {
          $.makeLott(LOTTERY_MENUS).map((category, index) => 
            <div className='category' key={index}>
              <div className='title'>{category.categoryName}：</div>
              <div className='lottery-items'>
                {
                  category.lotterys.map((lottery, index) => 
                    <div key={index} className={_.includes(favorites, lottery.lotteryId) ? 'check' : 'uncheck'} onClick={() => window.location.href = lottery.uri}>
                      <a className={_.includes(favorites, lottery.lotteryId) ? 'check' : 'uncheck'} 
                          onClick={(e) => this.handleSelectedLottery(e,lottery.lotteryId)}>
                        <span className='starFavor'>{_.includes(favorites, lottery.lotteryId) ? '取消收藏' : '加入收藏'}<i className="triangle-down"/></span>
                      </a>
                      <span className={_.includes(favorites, lottery.lotteryId) ? 'lotteryName check' : 'lotteryName uncheck'}>{lottery.name}</span>
                    </div>
                  )
                }
              </div>
            </div>
          )
        }
        <div className="favorSay">
          <div className="title">收藏说明:</div>
          <span>点击彩种名称前的 <i className="star"/> 可以添加或取消收藏，最多可同时收藏10个彩种</span>
        </div>
      </div>
    );
  }
}

